import { render } from "./CaseOpener.vue?vue&type=template&id=8364fe68&scoped=true"
import script from "./CaseOpener.vue?vue&type=script&lang=js"
export * from "./CaseOpener.vue?vue&type=script&lang=js"

import "./CaseOpener.vue?vue&type=style&index=0&id=8364fe68&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8364fe68"]])

export default __exports__